/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductSheetResponse } from '../../models/product-sheet-response';

export interface GetProductSheetById$Params {

/**
 * UUID of the product (PackagingUnit)
 */
  packagingUnitId: string;

/**
 * Marketplace section context: BUYING (default) or SELLING
 */
  marketplaceSection?: 'BUYING' | 'SELLING';
}

export function getProductSheetById(http: HttpClient, rootUrl: string, params: GetProductSheetById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductSheetResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductSheetById.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.query('marketplaceSection', params.marketplaceSection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductSheetResponse>;
    })
  );
}

getProductSheetById.PATH = '/products/{packagingUnitId}/sheet';
